import styled from 'styled-components';
import { Loader } from '@progress/kendo-react-indicators';
import { accentColorPrim } from './vars';

export const StyledLoader = styled(Loader)`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  background-color: rgb(255 255 255 / 70%);
  color: ${accentColorPrim};
`;
